import * as _ from 'underscore';
import { PopupMenuCtrl } from '../controllers/PopupMenuCtrl';
import { Module } from '../Module';

interface IPopupMenuButtonScope extends ng.IScope {
  popupMenu: PopupMenuCtrl;
}

interface IPopupMenuButtonDirective {
  name: string;
  templateUrl: string;
}

const buttons: IPopupMenuButtonDirective[] = [
  { name: 'tbPopupMenuButton', templateUrl: 'popupMenuButton.html' },
  { name: 'tbPopupMenuCustomButton', templateUrl: 'popupMenuCustomButton.html' },
  { name: 'tbPopupMenuSignatureButton', templateUrl: 'popupMenuSignatureButton.html' },
  { name: 'tbPopupMenuTextButton', templateUrl: 'popupMenuTextButton.html' }
];

_.each(buttons, (button: IPopupMenuButtonDirective) => {
  Module.instance().directive(button.name,
    () => {
      return {
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: button.templateUrl,
        scope: {},
        require: '^tbPopupMenu',
        link: (scope: IPopupMenuButtonScope, element: JQuery, attributes: ng.IAttributes, popupMenuCtrl: PopupMenuCtrl) => {
          popupMenuCtrl.setButton(element);
          scope.popupMenu = popupMenuCtrl;
        }
      };
    }
  );
});
